<template>
  <div class="flex items-start gap-2 p-2">
    <div class="shrink-0">
      <div
        :class="[isDragging ? 'cursor-grabbing' : 'cursor-grab']"
        :draggable="true"
        :style="{ opacity: 0.99999 }"
        @dragstart="handleDragStart"
        @dragend="handleDragEnd"
      >
        <MaterialResourceAvatar
          :material-resource-id="
            assignableMaterialResource.material_resource.id
          "
        />
      </div>
    </div>
    <div class="flex flex-1 flex-col gap-2">
      <div class="text-base font-semibold">
        {{ assignableMaterialResource.material_resource.name?.[$i18n.locale] }}
      </div>
      <ul
        v-if="!!assignableMaterialResource.events.length"
        class="flex flex-col gap-1"
      >
        <li
          v-for="event in assignableMaterialResource.events"
          :key="event.id"
          class="flex flex-row items-center gap-1"
        >
          <span>
            <div
              class="h-3 w-3 rounded-full"
              :class="assignmentColor(event.assignement_status)"
            />
          </span>
          <span
            class="rounded border border-slate-400 px-0.5 text-xs font-semibold"
          >
            {{ $h.momentLocalised(event.date_from, 'HH:mm') }}
            {{ $h.momentLocalised(event.date_to, 'HH:mm') }}
          </span>
          <span>{{ event.title }}</span>
        </li>
      </ul>

      <div
        v-if="withAvailability && availabilityItems.length > 0"
        class="flex w-full flex-col"
      >
        <table class="border-separate border-spacing-y-1.5">
          <tbody>
            <AvailabilityItem
              v-for="(availabilityItem, key) in availabilityItems"
              :key="key"
              :item="availabilityItem"
            />
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import MaterialResourceAvatar from '@c/Avatar/MaterialResourceAvatar.vue'
import { mapActions } from 'vuex'
import AvailabilityItem from '@c/Dashboard/Content/Planning/components/AvailabilityItem.vue'

export default {
  name: 'AssignableMaterialResource',
  components: { AvailabilityItem, MaterialResourceAvatar },
  props: {
    allAvailabilityItems: {
      type: Array,
      required: false,
      default: () => []
    },
    assignableMaterialResource: {
      type: Object,
      required: true
    },
    withAvailability: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      isDragging: false
    }
  },
  computed: {
    availabilityItems() {
      if (!this.withAvailability) {
        return []
      }

      return this.allAvailabilityItems.filter(
        (item) =>
          item.model_id === this.assignableMaterialResource.material_resource.id
      )
    }
  },
  methods: {
    ...mapActions({
      processSetDataTransferObjectAction: 'planning/setDataTransferObject'
    }),
    handleDragStart(event) {
      setTimeout(() => {
        event.target.classList.add('!opacity-0')
      }, 1)
      this.isDragging = true
      this.processSetDataTransferObjectAction({
        type: 'material-resource',
        model: this.assignableMaterialResource.material_resource,
        availabilityItems: this.availabilityItems
      })
    },
    handleDragEnd(event) {
      this.isDragging = false
      event.target.classList.remove('!opacity-0')

      this.processSetDataTransferObjectAction({})
    },
    assignmentColor(assignement_status) {
      switch (assignement_status) {
        case 'pending':
          return 'bg-yellow-500'
        case 'confirmed':
          return 'bg-green-500'
        case 'refused':
          return 'bg-red-500'
        default:
          return 'bg-slate-400'
      }
    }
  }
}
</script>
